// Others
import { IBaseOption } from '~/utils/interface/common';

export const mockDataScheduleType: IBaseOption[] = [
  {
    label: 'Booking A Job',
    value: 'JOB',
  },
  {
    label: 'Booking A Call',
    value: 'CONTACT',
  },
  {
    label: 'Booking A Return Customer',
    value: 'CUSTOMER',
  },
  {
    label: 'Event',
    value: 'EVENT',
  },
];

export const mockScheduleFilterData: IBaseOption[] = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Job',
    value: 'JOB',
  },
  {
    label: 'Estimate',
    value: 'ESTIMATE',
  },
  {
    label: 'Event',
    value: 'EVENT',
  },
];

export const mockCustomerScheduleFilterData: IBaseOption[] = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Job',
    value: 'JOB',
  },
  {
    label: 'Estimate',
    value: 'ESTIMATE',
  },
  // {
  //   label: 'Task',
  //   value: 'TASK',
  // },
];

export const mockJobScheduleFilterData: IBaseOption[] = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Estimate',
    value: 'ESTIMATE',
  },
  {
    label: 'Event',
    value: 'EVENT',
  },
  {
    label: 'Task',
    value: 'TASK',
  },
];
